import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { RiskListItem } from "ui/Scripts/source/models/risk/riskListItem";

interface IRiskListTraceabilityChipProps {
    icon?: React.ReactElement;
    riskLevel: number;
    fullWidth?: boolean;
}

export const RiskListTraceabilityChip = (props: IRiskListTraceabilityChipProps) => {
    const text = RiskListItem.getRiskTraceabilityText(props.riskLevel);
    const color = RiskListItem.getRiskTraceabilityColor(props.riskLevel);
    const textColor = Base.invertColor(color, true);

    return (
        <Tooltip title={text}>
            <Chip
                icon={props.icon}
                label={text}
                size="small"
                sx={{ backgroundColor: color, color: textColor, width: props.fullWidth ? "100%" : null }}
            />
        </Tooltip>
    );
};
